import React, { useEffect, useState } from 'react'
import { announcementService } from '../_services'
import { Alert } from 'react-bootstrap'

function AnnouncementComponent() {

	const [announcements, setAnnouncements] = useState([])
	const [language, setLanguage] = useState('EN')

	useEffect(() => {
		var language = navigator.language
		if (localStorage.getItem("i18nextLng")) {
			language = localStorage.getItem("i18nextLng")
		}

		if (language && language.includes('-')) {
			language = language.split('-')[0]
		}

		if (language) {
			setLanguage(language.toUpperCase())
		}

		getAnnouncements()
        const interval = setInterval(getAnnouncements, 300000)
        //const interval = setInterval(getAnnouncements, 10000) //10 seconds

        return () => {
            console.log('clearInterval')
            clearInterval(interval)
        }
	}, [])

    const getAnnouncements = () => {
        announcementService.getAnnouncements().then(announcements => {
            setAnnouncements(announcements)
        })
    }

    const handleClose = announcement => {
        announcementService.dismiss(announcement.id).then(result => {
            var newAnnouncements = announcements.filter(a => a != announcement)
            setAnnouncements(newAnnouncements)
        })
    }

    const translateAnnouncement = announcement => {
        return announcement.translations[language] || announcement.translations['EN']
    }

    return (
        <>
            { announcements.map(announcement => {
                if (!announcement.isRead) {
                    announcementService.markAsRead(announcement.id).then(response => {
		                announcement.isRead = true
		            })
                }
                return <Alert
                    key={'announcement-' + announcement.id}
                    style={{marginTop: '10px'}}
                    variant={announcement.type.toLowerCase()}
                    onClose={e => handleClose(announcement)}
                    dismissible={announcement.dismissible}
                >
	                { translateAnnouncement(announcement) }
	            </Alert>
            })}
        </>
    )
}

export default AnnouncementComponent